import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function createSlotsReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.CREATE_SLOTS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.CREATE_SLOTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload
            };
        case t.CREATE_SLOTS_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
